import { RTCBufferTypes } from '../constants/rtcBufferConstants';

const initialState = {
    inputBuffer: [],
    outputBuffer: []
};

const pop = (array) => {
    return [...array].slice(1);
}

export const rtcBufferReducer = (state = initialState, action) => {
    switch (action.type) {
        case RTCBufferTypes.BUFFER_INPUT_POP:
            return {
                ...state,
                inputBuffer: pop(state.inputBuffer)
            };
            
        case RTCBufferTypes.BUFFER_INPUT_PUSH:
            return {
                ...state,
                inputBuffer: [...state.inputBuffer, action.message]
            };

        case RTCBufferTypes.BUFFER_OUTPUT_POP:
            return {
                ...state,
                outputBuffer: pop(state.outputBuffer)
            };

        case RTCBufferTypes.BUFFER_OUTPUT_PUSH:
            return {
                ...state,
                outputBuffer: [...state.outputBuffer, action.message]
            };

        default:
            return state;
    }
};